/** Shared outer width for both app-bar search fields (palette footprint + toggler). */
export const APP_BAR_SEARCH_FIELD_MAX_WIDTH = 520;

export const APP_BAR_SEARCH_FIELD_MIN_WIDTH = {
    xs: 200,
    sm: 240,
    md: 360,
} as const;

/**
 * Shared InputBase padding so Nexus and System fields place the end adornment
 * the same distance from the field edge.
 */
export const getAppBarSearchFieldInputPaddingSx = (theme: { spacing: (n: number) => string | number }) => ({
    paddingTop: '4px !important',
    paddingBottom: '4px !important',
    paddingInlineStart: theme.spacing(1),
    paddingInlineEnd: theme.spacing(1),
});
